import {GameUtils} from "../utils/GameUtils";
import {GameAssets} from "../GameAssets";
import {BitMapMultiplier} from "./BitmapMultiplier";
import {TimelineSprite} from "../../core/animation/TimelineSprite";
import {Game} from "../Game";
import {gsap} from "gsap";

export class StickyDeadMultiplier extends PIXI.Container {
    private _icon: PIXI.Sprite;
    private _multiplier: BitMapMultiplier;
    private _count: PIXI.Text;
    private _fireCircleTls: TimelineSprite
    private _blastTls: TimelineSprite;
    private _isRemoved: boolean = false;

    constructor(name: string) {
        super();
        this.name = name;
        this.init();
    }

    public updateMultiplier(multiplier: number, count ?: number) {
        this._multiplier.value = multiplier;
        if (count) {
            this._count.text = count + "";
        } else {
            this._count.text = (+this._count.text + 1) + "";
        }
        this._multiplier.visible = multiplier > 1;
        if (this._multiplier.visible) {
            this.playBgFire();
        }
        this._count.visible = multiplier > 1;
    }

    public playBgFire(): void {
        this._fireCircleTls.playLoop();
    }

    public stopBGFire(): void {
        this._fireCircleTls.stopLoop();
    }

    private init(): void {
        this._icon = GameUtils.createSprite("m_symbol_icon/" + this.name + "_icon", undefined, true);
        this._multiplier = new BitMapMultiplier(GameAssets.BITMAP_FONT_X_MULTIPLIER_WIN_COUNT_UP, 10, "x");
        const countBG: PIXI.Sprite = this.createCircleBg();
        this._count = new PIXI.Text("", {
            fontFamily: "Titania",
            fontSize: 30,
            align: "center",
            fill: "#fff001",
            maxWidth: 30
        });
        this._multiplier.position.set(30, 30);
        this._count.anchor.set(0.5);
        this._count.text = "";
        this.updateMultiplier(1);
        this._count.position.set(40, -50);
        countBG.position.set(40, -50);
        const lock: PIXI.Sprite = GameUtils.createSprite("m_symbol_icon/lock_M_syms2", undefined, true);
        this._fireCircleTls = GameUtils.createTimelineSprite("fire_circle/fire_circle_000", 30, undefined, true);
        this._fireCircleTls.blendMode = PIXI.BLEND_MODES.ADD;
        this._fireCircleTls.scale.set(2.5);
        this._blastTls = this.createBlastTimelineSprite();
        this.addChild(this._fireCircleTls, this._icon, lock, this._multiplier, countBG, this._count, this._blastTls);
        this.scale.set(0.65);
    }

    private createCircleBg(): PIXI.Sprite {
        const img: PIXI.Sprite = new PIXI.Sprite(Game.assetLoader.getTextures("countup_circle/countup_circle")[0]);
        img.anchor.set(0.5);
        img.scale.set(1);
        return img;
    }

    private createBlastTimelineSprite(): TimelineSprite {
        const item: TimelineSprite = new TimelineSprite(Game.assetLoader.getTextures("multiplier_blast/multiplier_blast_"));
        item.hide();
        item.anchor.set(0.5);
        item.scale.set(1.35);
        item.blendMode = PIXI.BLEND_MODES.ADD;
        return item;
    }

    get isRemoved(): boolean {
        return this._isRemoved;
    }

    get count(): number {
        return +this._count.text;
    }

    set count(value: number) {
        this._count.text = value + "";
        if (value <= 0) {
            this._isRemoved = true;
            gsap.to(this, {
                alpha: 0, duration: 0.1, onComplete: () => {
                    this.stopBGFire();
                    this.parent?.removeChild(this);
                }
            });
        }
    }
}